import { createStackNavigator } from '@react-navigation/stack'

import { useTranslation } from '~hooks'
import { UserProfileScreen } from '~screens'
import { Routes } from '~types/routesNames'

const { Navigator, Screen } = createStackNavigator<UserStackParamList>()

export const UserStack = (): JSX.Element => {
  const { t } = useTranslation()
  return (
    <Navigator>
      <Screen
        component={UserProfileScreen}
        name={Routes.UserProfile}
        options={{ title: t('navigation.screen_titles.user_profile'), headerShown: false }}
      />
    </Navigator>
  )
}
